<template>
  <div class="notice">
    <div
      :style="{
        background: datas.backColor,
        'padding-top': datas.paddingTop + 'px',
        'padding-bottom': datas.paddingBottom + 'px',
        'padding-left': datas.paddingLeft + 'px',
        'padding-right': datas.paddingRight + 'px',
        'border-style': datas.borderStyle,
        'border-color': datas.borderColor,
        'border-width': datas.borderLineWeight + 'px',
        'border-radius': datas.borderRadius + 'px',
        'margin-top': datas.marginTop + 'px',
        'margin-bottom': datas.marginBottom + 'px',
        'margin-left': datas.marginLeft + 'px',
        'margin-right': datas.marginRight + 'px',
      }"
    >
      <div class="notice_con">
        <div class="notice_icon_con">
          <img
            class="full_img"
            :src="datas.iconImgUrl ? datas.iconImgUrl : defaultImg"
            alt=""
          />
        </div>
        <div class="scroll-container" :style="{ height: `${height}px` }">
          <ul
            v-for="(item, index) in list"
            :key="index"
            class="scroll-ul"
            :style="{
              transform: `translate3d(0, ${y}px, 0)`,
              transition: `${transition}`,
            }"
            @click="handleClickImg(item)"
          >
            <li
              class="c-item"
              :style="{
                height: heightArr[datas.styleType - 1] + 'px',
                'line-height': heightArr[datas.styleType - 1] + 'px',
              }"
            >
              <!-- <img
              v-if="item.content"
              class="a-item"
              :src="item.avatar"
            > -->
              <div
                v-if="item.content"
                class="c-content"
                :style="{
                  'font-size': datas.wordSize + 'px',
                  'font-weight': datas.isBold ? 'bold' : 'normal',
                  'font-style': datas.isTilt ? 'italic' : 'normal',
                  'text-decoration': datas.isUnderLine ? 'underline' : 'none',
                  color: datas.wordColor,
                }"
              >
                {{ item.content }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { handleScanCode } from "@/utils";
export default {
  name: "Notice",
  props: {
    datas: Object,
  },
  data() {
    return {
      defaultImg: require("@/assets/images/defaultPic2.png"),
      heightArr: [40, 22, 20],
      height: 0, // 单项高度
      y: 0, // 每次移动距离
      originLength: 0, // 原始数组长度
      transition: "ease all 1s",
      number: 1, // 默认一次滚动一条
      interval: null,
    };
  },
  computed: {
    list() {
      return this.datas.noticeList;
    },
  },
  mounted() {
    this.scroll();
  },
  methods: {
    scroll() {
      this.originLength = this.list.length;
      // 计算可视区域高度
      this.height =
        this.heightArr[this.datas.styleType - 1] * this.datas.styleType;
      console.log(this.height);
      console.log(this.list);
      let count = 0;
      this.y = 0;
      if (this.interval) clearInterval(this.interval);
      if (!this.list.length || this.list.length <= this.datas.styleType) return;
      this.interval = setInterval(() => {
        count += this.datas.styleType;
        this.y -=
          this.heightArr[this.datas.styleType - 1] * this.datas.styleType;
        this.transition = "ease all 2s";
        setTimeout(() => {
          if (count >= this.originLength) {
            count = 0;
            this.transition = "";
            this.y = 0;
          }
        }, 1000);
      }, this.datas.carouselInterval);
    },
    handleClickImg(item) {
      if (item.linkType == "scanCode") {
        // 调起微信扫码，扫码取号并自动跳转到扫码信息页面
        handleScanCode();
      } else if (item.linkUrl) {
        window.location.href = item.linkUrl;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.notice {
  position: relative;
  .notice_con {
    display: flex;
    .notice_icon_con {
      align-self: center;
      width: 80px;
      height: 80px;
      margin-right: 20px;
    }
  }
  .scroll-container {
    flex: 1;
    overflow: hidden;
  }
  .c-item {
    box-sizing: border-box;
    color: #333;
  }
  .c-content {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
